/** CloudFront base for course hero objects (set at web build from Storage stack output). */
export function mediaPublicBaseUrl(): string {
  return import.meta.env.VITE_MEDIA_PUBLIC_BASE_URL?.trim().replace(/\/+$/, "") ?? "";
}

/** Prefer API-resolved URL; fall back to key + public media base when the API omits the URL. */
export function resolveCourseHeroImageUrl(input: {
  heroImageUrl?: string | null;
  heroImageKey?: string | null;
}): string | null {
  const fromApi = input.heroImageUrl?.trim();
  if (fromApi) return fromApi;
  const key = input.heroImageKey?.trim();
  const base = mediaPublicBaseUrl();
  if (key && base) return `${base}/${key}`;
  return null;
}
